var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10.01 10.01 0 0 1 0 20 10.01 10.01 0 0 1 0-20Zm0-2a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.86c0-.48.4-.86.88-.86h10.24c.49 0 .88.38.88.86v10.28c0 .48-.4.86-.88.86H6.88a.87.87 0 0 1-.88-.86V6.86Zm3.7 9.19v-5.42H7.9v5.42h1.8Zm-.9-6.16c.63 0 1.03-.42 1.03-.94-.02-.53-.4-.94-1.01-.94-.62 0-1.02.4-1.02.94 0 .52.4.94 1 .94Zm3.69 6.16v-3.03c0-.16.01-.32.06-.44.13-.32.42-.66.92-.66.65 0 .91.5.91 1.23v2.9h1.8v-3.11c0-1.67-.88-2.44-2.07-2.44-.95 0-1.38.52-1.62.9v.01h-.01v-.78h-1.8c.03.5 0 5.42 0 5.42h1.8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fdd150c5bbfaef2f063054f68a6ca9e5.svg";
export { ForwardRef as ReactComponent };